const JumpHandler = {
  init({
    btnJumpPage,
    jumpPageContainer,
    formInputSurah,
    inputNumSurah,
    formBtnSubmitInputSurah,
    formBtnCloseInputSurah,
  }) {
    this._jumpPage({ btnJumpPage, jumpPageContainer, inputNumSurah });
    this._inputPage(inputNumSurah, formBtnSubmitInputSurah);
    this._searchPage(formInputSurah, inputNumSurah);
    this._cancelJumpPage({ formBtnCloseInputSurah, jumpPageContainer, formBtnSubmitInputSurah });
  },

  _jumpPage({ btnJumpPage, jumpPageContainer, inputNumSurah }) {
    btnJumpPage.addEventListener('click', () => {
      jumpPageContainer.classList.remove('hidden');
      inputNumSurah.focus();
    });
  },

  _inputPage(inputNumSurah, formBtnSubmitInputSurah) {
    inputNumSurah.addEventListener('input', () => {
      if (inputNumSurah.value) {
        formBtnSubmitInputSurah.classList.remove('bg-[#aaa]');
        formBtnSubmitInputSurah.classList.add('bg-[#0B666A]');
        formBtnSubmitInputSurah.disabled = false;
      } else {
        formBtnSubmitInputSurah.classList.add('bg-[#aaa]');
        formBtnSubmitInputSurah.classList.remove('bg-[#0B666A]');
        formBtnSubmitInputSurah.disabled = true;
      }
    });
  },

  _searchPage(formInputSurah, inputNumSurah) {
    formInputSurah.addEventListener('submit', (event) => {
      event.preventDefault();
      location.assign(`#/surah/${inputNumSurah.value}`);
    });
  },

  _cancelJumpPage({ formBtnCloseInputSurah, jumpPageContainer, formBtnSubmitInputSurah }) {
    formBtnCloseInputSurah.addEventListener('click', () => {
      jumpPageContainer.classList.add('hidden');
      formBtnSubmitInputSurah.classList.add('bg-[#aaa]');
      formBtnSubmitInputSurah.classList.remove('bg-[#0B666A]');
      formBtnSubmitInputSurah.disabled = true;
    });
  },
};

export default JumpHandler;
